import { useIsMounted } from 'custom_hooks/useIsMounted';
import { useCallback } from 'react';

/**
 * @returns a function that behaves like `setTimeout` but will not execute the
 * callback if the parent component was unmounted.
 */
export function useDefer() {
    const isMountedRef = useIsMounted();

    return useCallback(
        (callback: () => void, ms: number) =>
            setTimeout(() => {
                if (isMountedRef.current) {
                    callback();
                }
            }, ms),
        [isMountedRef],
    );
}
